export interface InfantStory {
  id: string;
  infantName: string;
  age: string;
  country: string;
  flag: string;
  need: string;
  story: string;
  image: string;
  familyImage: string;
  giftReceived?: string;
  giftPhoto?: string;
  donorName?: string;
  donorCountry?: string;
  funded: boolean;
  amountNeeded: number;
  amountRaised: number;
}

export const infantStories: InfantStory[] = [
  {
    id: "inf1",
    infantName: "Amira",
    age: "4 months",
    country: "Yemen",
    flag: "🇾🇪",
    need: "Milk & Nutrition",
    story: "Little Amira was born in a small village in Yemen. Her mother works hard every day but cannot afford formula milk. Amira needs nutritional support for her first year of life.",
    image: "https://public.readdy.ai/ai/img_res/2a36399a182cb9572687fa663c0e9ff1.jpg",
    familyImage: "https://readdy.ai/api/search-image?query=loving%20mother%20holding%20newborn%20baby%20warm%20light%20gentle%20family%20portrait%20Yemen%20village%20home%20soft%20natural%20photography&width=400&height=300&seq=infam1&orientation=landscape",
    funded: false,
    amountNeeded: 120,
    amountRaised: 75,
  },
  {
    id: "inf2",
    infantName: "Kofi",
    age: "7 months",
    country: "Ghana",
    flag: "🇬🇭",
    need: "Clothes & Warmth",
    story: "Baby Kofi lives with his grandmother in rural Ghana. He has outgrown all his clothes and needs warm clothing for the coming rainy season. His grandmother sends blessings to every donor.",
    image: "https://readdy.ai/api/search-image?query=adorable%20baby%20boy%207%20months%20old%20bright%20eyes%20happy%20smile%20innocent%20beautiful%20portrait%20photography%20warm%20golden%20light%20Africa&width=400&height=400&seq=inf2&orientation=squarish",
    familyImage: "https://readdy.ai/api/search-image?query=grandmother%20holding%20baby%20boy%20warm%20light%20gentle%20family%20portrait%20Ghana%20village%20home%20soft%20natural%20photography%20love&width=400&height=300&seq=infam2&orientation=landscape",
    giftReceived: "Handwoven Kente cloth bracelet",
    giftPhoto: "https://readdy.ai/api/search-image?query=handwoven%20colorful%20Kente%20cloth%20bracelet%20Ghana%20traditional%20gift%20white%20background%20beautiful%20craft&width=400&height=300&seq=infgift2&orientation=landscape",
    donorName: "Sarah M.",
    donorCountry: "United Kingdom",
    funded: true,
    amountNeeded: 80,
    amountRaised: 80,
  },
  {
    id: "inf3",
    infantName: "Fatima",
    age: "2 months",
    country: "Somalia",
    flag: "🇸🇴",
    need: "Milk & Clothes",
    story: "Tiny Fatima arrived early and needs special formula milk and soft clothing. Her mother weaves beautiful baskets and promises to send a handmade basket as a thank-you gift to her donor.",
    image: "https://readdy.ai/api/search-image?query=adorable%20newborn%20baby%20girl%202%20months%20old%20peaceful%20sleeping%20innocent%20beautiful%20portrait%20photography%20soft%20warm%20light%20gentle&width=400&height=400&seq=inf3&orientation=squarish",
    familyImage: "https://readdy.ai/api/search-image?query=mother%20holding%20tiny%20newborn%20baby%20warm%20light%20gentle%20family%20portrait%20Somalia%20home%20soft%20natural%20photography%20love%20care&width=400&height=300&seq=infam3&orientation=landscape",
    funded: false,
    amountNeeded: 150,
    amountRaised: 40,
  },
  {
    id: "inf4",
    infantName: "Miguel",
    age: "5 months",
    country: "Haiti",
    flag: "🇭🇹",
    need: "Nutrition & Care",
    story: "Baby Miguel lost his father in the earthquake. His young mother is doing everything she can. Miguel needs nutritional supplements and basic care items. His family will send a painted tile as a gift.",
    image: "https://readdy.ai/api/search-image?query=adorable%20baby%20boy%205%20months%20old%20curious%20bright%20eyes%20innocent%20beautiful%20portrait%20photography%20warm%20light%20gentle%20Haiti&width=400&height=400&seq=inf4&orientation=squarish",
    familyImage: "https://readdy.ai/api/search-image?query=young%20mother%20holding%20baby%20boy%20warm%20light%20gentle%20family%20portrait%20Haiti%20home%20soft%20natural%20photography%20love%20resilience&width=400&height=300&seq=infam4&orientation=landscape",
    giftReceived: "Hand-painted Haitian ceramic tile",
    giftPhoto: "https://readdy.ai/api/search-image?query=hand%20painted%20Haitian%20ceramic%20tile%20colorful%20traditional%20art%20white%20background%20beautiful%20craft%20gift&width=400&height=300&seq=infgift4&orientation=landscape",
    donorName: "Ahmed K.",
    donorCountry: "UAE",
    funded: true,
    amountNeeded: 100,
    amountRaised: 100,
  },
  {
    id: "inf5",
    infantName: "Priya",
    age: "3 months",
    country: "Bangladesh",
    flag: "🇧🇩",
    need: "Milk & Warmth",
    story: "Sweet Priya was born during monsoon season in a flood-affected area of Bangladesh. Her family lost their home but not their love. Priya needs formula milk and warm clothes to stay healthy.",
    image: "https://readdy.ai/api/search-image?query=adorable%20baby%20girl%203%20months%20old%20sweet%20smile%20innocent%20beautiful%20portrait%20photography%20warm%20soft%20light%20gentle%20Bangladesh&width=400&height=400&seq=inf5&orientation=squarish",
    familyImage: "https://readdy.ai/api/search-image?query=mother%20father%20holding%20baby%20girl%20warm%20light%20gentle%20family%20portrait%20Bangladesh%20home%20soft%20natural%20photography%20love%20hope&width=400&height=300&seq=infam5&orientation=landscape",
    funded: false,
    amountNeeded: 90,
    amountRaised: 55,
  },
  {
    id: "inf6",
    infantName: "Zara",
    age: "6 months",
    country: "Sudan",
    flag: "🇸🇩",
    need: "Clothes & Nutrition",
    story: "Baby Zara has the most beautiful smile in her village. Her family fled conflict and is rebuilding their life. Zara needs clothing and nutritional support. Her mother embroiders and will send a handmade gift.",
    image: "https://readdy.ai/api/search-image?query=adorable%20baby%20girl%206%20months%20old%20beautiful%20smile%20innocent%20portrait%20photography%20warm%20golden%20light%20gentle%20Sudan%20Africa&width=400&height=400&seq=inf6&orientation=squarish",
    familyImage: "https://readdy.ai/api/search-image?query=mother%20holding%20smiling%20baby%20girl%20warm%20light%20gentle%20family%20portrait%20Sudan%20Africa%20home%20soft%20natural%20photography%20love&width=400&height=300&seq=infam6&orientation=landscape",
    funded: false,
    amountNeeded: 110,
    amountRaised: 30,
  },
];

export const donationImpacts = [
  { amount: 25, label: "1 Month of Formula Milk", icon: "ri-heart-fill" },
  { amount: 50, label: "Full Clothing Set (0–12 months)", icon: "ri-shirt-line" },
  { amount: 100, label: "3 Months Nutrition + Clothes", icon: "ri-gift-fill" },
  { amount: 250, label: "6 Months Full Care Package", icon: "ri-star-fill" },
  { amount: 500, label: "1 Year Complete Support", icon: "ri-vip-crown-fill" },
];
